import React from 'react';
import { useTheme } from '@emotion/react';
import { FormHelperText } from '@mui/material';
import { FunnelTextArea } from '@bbkFunnel/components/v2';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { type SurveyMultiRowResponseHandler } from '@bbkFunnelComponents/survey-multi-row';

type Props = {
  value?: string;
  handler: SurveyMultiRowResponseHandler;
  question: { placeholder: string };
  error?: string;
};

export const FeedbackContent: React.FC<Props> = ({
  value,
  handler,
  question,
  error,
}) => {
  const { placeholder = 'Start typing...' } = question;
  const theme = useTheme() as EmotionTheme;
  return (
    <>
      <FunnelTextArea
        name="feedback"
        value={value}
        placeholder={placeholder}
        onChange={(e) =>
          handler(e, e.target.value, undefined, undefined, {
            type: 'change',
          })
        }
        onBlur={(e) =>
          handler(e, e.target.value, undefined, undefined, {
            type: 'change',
          })
        }
        maxLength={500}
      />
      {error && (
        <FormHelperText style={{ fontSize: 12, color: theme.errorVal }}>
          {error}
        </FormHelperText>
      )}
    </>
  );
};
